import { render } from "./VoiceClone.vue?vue&type=template&id=49a69564&scoped=true"
import script from "./VoiceClone.vue?vue&type=script&lang=js"
export * from "./VoiceClone.vue?vue&type=script&lang=js"

import "./VoiceClone.vue?vue&type=style&index=0&id=49a69564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a69564"]])

export default __exports__